import '../DataTableScrollShadow.css';
import './DataTablePinningShadowCells.css';
export var leftPositionVar = 'var(--_1tlws2p0-3-15-1)';
export var pinningShadowCell = {left:'_1tlws2p2-3-15-1 _1al677r1-3-15-1 _1al677r0-3-15-1',right:'_1tlws2p3-3-15-1 _1al677r2-3-15-1 _1al677r0-3-15-1'};
export var rightPositionVar = 'var(--_1tlws2p1-3-15-1)';